import { Action } from '../actions/vehicles';
import { setModelsToMap } from '../../lib/utils/vehicle';

const defaultState = {
  isFetching: false,
  fetchComplete: false,
  modelsMap: {},
  error: undefined,
};

export default function vehicleModelsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action.type) {
    case Action.Vehicle.FetchModelsPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
        fetchComplete: false,
      };

    case Action.Vehicle.FetchModelsCompleted: {
      const { models } = body;
      const modelsMap = { ...state.modelsMap };
      const { modelCacheKey } = action.meta;
      setModelsToMap(modelCacheKey, models, modelsMap);
      return {
        ...state,
        isFetching: false,
        fetchComplete: true,
        modelsMap,
      };
    }

    case Action.Vehicle.FetchModelsFailed:
      return {
        ...state,
        isFetching: false,
        error: 'An error occurred fetching vehicle models. Please try again later.',
      };
    default:
      return state;
  }
}
